import { IRouteState } from "@/store/modules/routePath/state";

export const mutations = {
  setRoutePath: (state: IRouteState, data: string) => {
    state.currentPath = data;
  }
};
